<template>
    <div v-show="isActive"><slot v-if="isActive"></slot></div>
</template>

<script>
export default {
    name: 'Tab',
    props: {
        name: { required: true },
        subtitle: String,
        side: String,
        selected: { default: false },
        disabled: Boolean,
        icon: String,
        css: String
    },
    data() {
        return {
            isActive: false
        };
    },
    watch: {
        'isActive': {
            immediate: true,
            handler(active) {
                if (active) {
                    this.$emit('showed', this);
                }
            }
        },
        'selected': {
            immediate: true,
            handler(selected) {
                this.isActive = selected
            }
        }
    }
}
</script>
